export const VaccinationType = {
    PRIMARY: 'PRIMARY',
    BOOSTER: 'BOOSTER',
};

export type TVaccinationType = typeof VaccinationType[keyof typeof VaccinationType];
